import { render, staticRenderFns } from "./ReferenceFilterFullTextReviewStatus.vue?vue&type=template&id=5c716c3e&"
import script from "./ReferenceFilterFullTextReviewStatus.vue?vue&type=script&lang=js&"
export * from "./ReferenceFilterFullTextReviewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports